module.exports = __webpack_public_path__ + "img/Mask Group 94.20f6c378.svg";